import { Component, Input } from "@angular/core";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { ExpenseManagementService } from "@app/expense-management/services";
import { numbersWithDecimal } from "app/modules/shared/shared.constants";
import { Subscription } from "rxjs";

@Component({
    selector: "app-trip-details",
    templateUrl: "./trip-details.component.html",
    styleUrls: ["./trip-details.component.scss"],
    standalone: false
})
export class TripDetailsComponent {
  @Input()
  approvalDetail;

  constructor(public expenseManagementService: ExpenseManagementService) {}

  ngOnInit(): void {

  }
}
